import AppConfig from "../../app.config";
import { toasts } from "svelte-toasts";
import Session from "./Session";
export default class Purchase {
    static async get(toClearance) {
        const paramsQuery = `${toClearance !== undefined ? `&toClearance=${toClearance}` : ''}`;
        const token = Session.getToken();
        const res = await fetch(`${AppConfig.REST.URL}/purchase/?token=${token}${paramsQuery}`);
        const json = await res.json();
        return json;
    }
    static async add(product, paid) {
        const token = Session.getToken();
        const body = new URLSearchParams();
        body.append("token", token);
        body.append("product", product);
        body.append("paid", paid.toString());
        const res = await fetch(`${AppConfig.REST.URL}/purchase`, { method: 'POST', body });
        const json = await res.json();
        return json;
    }
    static async changePaymentStatus(purchase, status) {
        const body = new URLSearchParams();
        body.append("paid", status.toString());
        const res = await fetch(`${AppConfig.REST.URL}/purchase/${purchase}`, { method: 'PUT', body });
        const json = await res.json();
        if (res.status == 200) {
            if (status)
                toasts.success(`Sukces`, `Oznaczyliśmy zakup jako opłacony.`);
            else
                toasts.success(`Sukces`, `Płatność została anulowana, a Twój zakup został oznaczony jako nieopłacony.`);
        }
        return json;
    }
    static async clearancePurchase(purchase) {
        const token = Session.getToken();
        const body = new URLSearchParams();
        body.append("completed", "true");
        const res = await fetch(`${AppConfig.REST.URL}/purchase/${purchase}/?token=${token}`, { method: 'PUT', body });
        const json = await res.json();
        if (res.status == 200)
            toasts.success(`Sukces`, `Zakup został rozliczony.`);
        return json;
    }
    static async clearAllPaidPurchases() {
        const token = Session.getToken();
        const res = await fetch(`${AppConfig.REST.URL}/purchase/clear/all/?token=${token}`, { method: 'PUT' });
        const json = await res.json();
        if (res.status == 200)
            toasts.success(`Sukces`, `Wszystkie opłacone zakupy zostały oznaczone jako rozliczone.`);
        return json;
    }
    static async remove(purchase) {
        const token = Session.getToken();
        const res = await fetch(`${AppConfig.REST.URL}/purchase/${purchase}?token=${token}`, { method: 'DELETE' });
        if (res.status == 204)
            toasts.success(`Sukces`, `Zakup został usunięty.`);
        return res ? true : false;
    }
}
